import hcSticky from 'hc-sticky'

new hcSticky('.main-article__sidebar-inner', {
  stickTo: '.main-article__sidebar',
  top: 130,
})

document.querySelectorAll('ul.recipe li').forEach((recipeListItem) => {
  recipeListItem.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()

    recipeListItem.classList.toggle('active')
  })
})
